import { FormControl, InputBaseComponentProps, OutlinedInput, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { IMaskInput } from 'react-imask';

interface MonetaryMaskProps extends InputBaseComponentProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
}

const MonetaryMask = React.forwardRef<HTMLInputElement, MonetaryMaskProps>((props, ref) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      mask={Number}
      radix=","
      thousandsSeparator="."
      padFractionalZeros
      normalizeZeros
      min={0}
      max={999999999}
      scale={2}
      placeholder="0,00"
      unmask
      inputRef={ref}
      onAccept={(value: string) => {
        onChange({ target: { name: props.name, value } } as React.ChangeEvent<HTMLInputElement>);
      }}
      overwrite
    />
  );
});

MonetaryMask.displayName = 'TextMaskCustom';

interface AmountFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  sx?: SxProps<Theme>;
  disable?: boolean;
}

export default function AmountField(props: AmountFieldProps) {
  const { label, value, onChange, sx, disable = false } = props;

  return (
    <FormControl>
      <Typography sx={{ fontWeight: 'bold' }}>{label}</Typography>
      <OutlinedInput
        disabled={disable}
        sx={{
          ...sx,
          height: 35,
          '& .MuiInputBase-input.Mui-disabled': {
            WebkitTextFillColor: '#dedede',
          },
        }}
        value={value ? String(value) : '0'}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onChange(event.target.value ? Number(event.target.value) : 0);
        }}
        inputComponent={MonetaryMask}
        inputProps={{ 'aria-label': label }}
      />
    </FormControl>
  );
}
